export default "__VITE_ASSET__BviMEl4S__"